import PlaylistTabContainer from './PlaylistTabContainer'

export default PlaylistTabContainer
export { TABS, type CollectionsTab } from './PlaylistTabContainer'
